import React, { useState } from 'react';
import Timeline from '../components/Timeline';
import { momentsByMonth } from '../data/moments';

type Moment = {
    name: string;
    date: string;
    theme: string;
    photos: string[];
};

type MomentsByMonth = {
    [month: string]: Moment[];
};

const MomentsPage: React.FC = () => {
    const [openMoment, setOpenMoment] = useState<{ [key: string]: number | null }>({});

    const handleToggle = (month: string, idx: number) => {
        setOpenMoment((prev) => ({
            ...prev,
            [month]: prev[month] === idx ? null : idx,
        }));
    };

    return (
        <main 
            id="main-content"
            className="moments-page max-w-7xl mx-auto px-4 py-8"
            aria-label="Página de momentos marcantes"
        >
            <h1 className="text-3xl md:text-4xl font-bold text-gold mb-8 text-center md:text-left">Momentos Marcantes de 2025</h1>
            {Object.entries(momentsByMonth).map(([month, moments]) => (
                <section key={month} className="mb-8" aria-labelledby={`month-${month}`}>
                    <h2 id={`month-${month}`} className="text-xl md:text-2xl font-semibold text-gold mb-4">{month}</h2>
                    {moments.length === 0 && (
                        <p className="text-white/50 italic mb-4">Nenhum momento registrado neste mês.</p>
                    )}
                    <div className="space-y-4">
                        {moments.map((moment, idx) => (
                            <div key={moment.name} className="bg-gray-900 rounded-lg shadow-lg">
                                <button
                                    className="w-full flex justify-between items-center px-4 md:px-6 py-4 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-gold"
                                    onClick={() => handleToggle(month, idx)}
                                    aria-expanded={openMoment[month] === idx}
                                    aria-controls={`moment-${month}-${idx}`}
                                >
                                    <span className="text-base md:text-lg font-bold text-gold">{moment.name}</span>
                                    <span
                                        className={`transform transition-transform duration-200 ${
                                            openMoment[month] === idx ? 'rotate-90' : ''
                                        }`}
                                        aria-hidden="true"
                                    >
                                        ▶
                                    </span>
                                </button>
                                {openMoment[month] === idx && (
                                    <div id={`moment-${month}-${idx}`} className="px-4 md:px-6 pb-6">
                                        <p className="text-white/70 mb-2 text-sm md:text-base">
                                            <span className="font-semibold">{moment.date}</span> — <span className="italic">{moment.theme}</span>
                                        </p>
                                        <Timeline moments={[moment]} />
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </section>
            ))}
        </main>
    );
};

export default MomentsPage;